import styled from 'styled-components';

export const Container = styled.div`
  .box {
    margin-bottom: 30px;
  }

  .profile-image {
    width: 50px;
    height: 50px;
    margin: 0 auto;
    background-size: cover;
    background-color: #eaeaea;
    background-position: center;
    border-radius: 100px;
  }

  .modal {
    th,
    td {
      border: 0;
    }
  }

  .send-advertence {
    margin: 10px 0 0 auto;
  }

  select {
    font-size: 16px;
  }
`;

export const ButtonPanel = styled.div`
  margin-bottom: 20px;
  display: flex;

  .align-right {
    margin-left: auto;
  }

  & > * {
    margin-right: 10px;
  }
`;

export const Table = styled.table`
  text-align: center;
  margin-bottom: 0;

  td,
  th {
    vertical-align: middle;
  }

  .btn-small {
    padding: 1px 7px;
    font-size: 12px;
    margin: 0 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/EvaluatePromoters/styles.js